/**
 * Abre a conversa do WhatsApp com o proprietário já com a mensagem preenchida — o mesmo
 * caminho que o compartilhamento do checklist e o envio da pesquisa fazem inline.
 *
 * O link é montado a partir da origem da PRÓPRIA tela (`window.location.origin`): o backend
 * nunca monta endereço de frontend (a env de origem é uma lista — at-70).
 */
export const linkDoWhatsApp = (telefone: string | null | undefined, mensagem: string): string => {
  const digitos = String(telefone || '').replace(/\D/g, '');
  const comPais = digitos.startsWith('55') && digitos.length >= 12 ? digitos : `55${digitos}`;
  return `https://wa.me/${comPais}?text=${encodeURIComponent(mensagem)}`;
};

export const abrirWhatsApp = (telefone: string | null | undefined, mensagem: string): void => {
  window.open(linkDoWhatsApp(telefone, mensagem), '_blank', 'noopener');
};

/** Mensagem da ação "Compartilhar Acompanhamento": `{{link}}`, `{{placa}}` e `{{nome}}`. */
export const montarMensagemDoAcompanhamento = (
  share: { token: string; template: string; plate: string; ownerName: string | null },
  origem: string = window.location.origin,
): string =>
  share.template
    .replace(/\{\{link\}\}/g, `${origem}/acompanhamento/${share.token}`)
    .replace(/\{\{placa\}\}/g, share.plate || '')
    .replace(/\{\{nome\}\}/g, share.ownerName || 'cliente');
